import { render, staticRenderFns } from "./AppFoot.vue?vue&type=template&id=a0c0809a&scoped=true"
import script from "./AppFoot.vue?vue&type=script&lang=js"
export * from "./AppFoot.vue?vue&type=script&lang=js"
import style0 from "./AppFoot.vue?vue&type=style&index=0&id=a0c0809a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c0809a",
  null
  
)

export default component.exports